import { useQuery, gql, QueryHookOptions } from '@apollo/client'
import Organization from '@/gf/modules/Organization'

import { OrganizationPayload } from '../../types'

import { Pagination } from '../types'

interface Data {
  customerOrganizations: {
    pagination: Pagination
    organizations: OrganizationPayload[]
  }
}

interface Variables {
  page?: number
}

const query = gql`
  query CustomerOrganizations($page: Int) {
    customerOrganizations(page: $page) {
      organizations {
        id
        name
        phoneNumber
        openOrdersCount
        closedOrdersCount
        lastActivityDate
      }
      pagination {
        totalPages
        totalResults
      }
    }
  }
`

const useSearchOrganizations = (options?: QueryHookOptions<Data, Variables>) => {
  const result = useQuery(query, { ...options, fetchPolicy: 'no-cache' })

  const data = result.data && {
    ...result.data,
    customerOrganizations: {
      ...result.data.customerOrganizations,
      organizations: result.data.customerOrganizations.organizations.map(Organization.fromPayload),
    },
  }

  return { ...result, data }
}

export default useSearchOrganizations
